export default "__VITE_ASSET__C3wuKG4S__"